import OutlineTitle from "@/components/OutlineTitle";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { marketplaceAPI } from "@/lib/api";
import ListingCard from "@/components/ListingCard";
import OrderSuppliesButton from "@/components/OrderSuppliesButton";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Plus, ShoppingBag } from "lucide-react";

export default function MyListings() {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = () => {
    setLoading(true);
    marketplaceAPI.getMyListings()
      .then((r) => setListings(Array.isArray(r.data) ? r.data : r.data?.listings || []))
      .catch(() => setListings([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { reload(); }, []);

  return (
    <div className="mx-auto max-w-5xl space-y-6" data-testid="my-listings-page">
      <div className="flex items-center justify-between">
        <div>
          <OutlineTitle>My Listings</OutlineTitle>
        </div>
        <Link to="/marketplace/create">
          <Button className="bg-primary text-primary-foreground hover:bg-primary/90" data-testid="my-listings-create">
            <Plus className="mr-1 h-4 w-4" /> New listing
          </Button>
        </Link>
      </div>

      {loading ? (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} className="aspect-[3/4] rounded-lg" />)}
        </div>
      ) : listings.length ? (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {listings.map((l) => (
            <div key={l.id} className="flex flex-col gap-2">
              <ListingCard listing={l} />
              {!l.has_original_packaging && l.shipping_category && (
                <OrderSuppliesButton listing={l} onDone={reload} testId={`my-listings-supplies-${l.id}`} />
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center gap-3 rounded-lg border border-dashed border-border p-10 text-center">
          <ShoppingBag className="h-8 w-8 text-muted-foreground" />
          <p className="text-sm text-muted-foreground">You don&apos;t have any listings yet.</p>
          <Link to="/marketplace/create">
            <Button className="bg-primary text-primary-foreground hover:bg-primary/90">Create your first listing</Button>
          </Link>
        </div>
      )}
    </div>
  );
}
